<template>
  <div>
    <div  style="cursor: pointer;margin-bottom: 16px;color: #fff;" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>

    <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" :colon="false" :form="form" @submit="handleSubmit">
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="所属分类" id="category" :disabled = "view === '修改检查井'"
                         :modelValue="form.category" :options="pipeTypes" required labelWidth="40%"
                         @update:modelValue="(value) => handleModelValueUpdate('category', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="井类型" id="type" :disabled = "view === '修改检查井'"
                         :modelValue="form.type" :options="wellTypes" required labelWidth="40%"
                         @update:modelValue="(value) => handleModelValueUpdate('type', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                        :modelValue="form.code" placeholder="请输入编号" required
                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="经纬度" type="text" id="lnglat" :disabled = "view === '修改检查井'"
                        :modelValue="form.lnglat" placeholder="请输入经纬度" inputImg required
                        @img-click="pasteLnglat"
                        @update:modelValue="(value) => handleModelValueUpdate('lnglat', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="所在位置" type="text" id="location"
                        :modelValue="form.location" placeholder="请输入位置"
                        @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="井盖直径(m)" type="number" id="diameterCover"
                        :modelValue="form.diameterCover" placeholder="请输入井盖直径(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('diameterCover', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="井室直径(m)" type="number" id="diameterRoom"
                        :modelValue="form.diameterRoom" placeholder="请输入井室直径(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('diameterRoom', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="地面高程(m)" type="number" id="elevation"
                        :modelValue="form.elevation" placeholder="请输入地面高程(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('elevation', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="井盖材质" type="text" id="materialCover"
                        :modelValue="form.materialCover" placeholder="请输入井盖材质"
                        @update:modelValue="(value) => handleModelValueUpdate('materialCover', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="检查井材质" type="text" id="materialWell"
                        :modelValue="form.materialWell" placeholder="请输入检查井材质"
                        @update:modelValue="(value) => handleModelValueUpdate('materialWell', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="井盖形状" type="text" id="shapeCover"
                        :modelValue="form.shapeCover" placeholder="请输入井盖形状"
                        @update:modelValue="(value) => handleModelValueUpdate('shapeCover', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="井深" type="number" id="depth"
                        :modelValue="form.depth" placeholder="请输入井深"
                        @update:modelValue="(value) => handleModelValueUpdate('depth', value)"
            />
        </a-col>

        <a-col :lg="24" :md="24" :sm="24">
            <div style="width: 95%;margin: auto;">
                <div style="color: #93a2b7;margin-bottom: 1rem;"><span style="visibility: hidden;">*</span>关联管道</div>
                <PipeTable
                        :category="form.category"
                        :list="pipeList"
                        :disabled="view === '修改检查井'"
                        @change="payload => pipeList = payload"
                />
            </div>
        </a-col>
      </a-row>

      <div class="center" style="margin-top: 1rem;">
        <a-space>
            <ButtonField text="取消" @click="back" secondary />
            <ButtonField text="保存" primary @click="handleSubmit"/>
        </a-space>
      </div>
    </a-form>
  </div>
</template>
<script>
import store from "../mixins/store";
import { mapGetters } from "vuex";
import PipeTable from "../components/pipe-table";
import { add, edit, fetchDetail } from "@/api/assets/inspectWell.js";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";

export default {
  mixins: [store],

  components: {
      InputField,SelectField,ButtonField,PipeTable
  },

  data() {
    return {
      wellTypes: [],

      detail: {},
      form: {
          category:null,
          type:null,
          code:null,
          lnglat:null,
          location:null,
          diameterCover:null,
          diameterRoom:null,
          elevation:null,
          materialCover:null,
          materialWell:null,
          shapeCover:null,
          depth:null,
      },

      pipeList: [],
      saveLoading: false,
    };
  },

  watch: {
    selectedWell: {
      handler() {
        if (this.view === "修改检查井" && this.selectedWell._edit) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    pipeTypes() {
      return this.findDataDict("pipeType");
    },
    rainWellTypes() {
      return this.findDataDict("rainWellType");
    },
    sewageWellTypes() {
      return this.findDataDict("sewageWellType");
    },
  },

  mounted() {
    if (this.view === "修改检查井" && this.selectedWell._edit) {
      this.getDetail();
    }
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    getDetail() {
      this.wellTypes = [];
      this.detail = {};
      this.form = {
          category:null,
          type:null,
          code:null,
          lnglat:null,
          location:null,
          diameterCover:null,
          diameterRoom:null,
          elevation:null,
          materialCover:null,
          materialWell:null,
          shapeCover:null,
          depth:null,
      }
      this.pipeList = [];
      const hide = this.$message.loading("加载中...", 0);
      fetchDetail({
        id: this.selectedWell.id,
        category: this.selectedWell.category,
      })
        .then((res) => {
          if (!res.id) return;
          this.detail = res;

          this.form.code = res.code;
          this.form.category = res.category;
          this.form.type = res.type;
          this.form.location = res.location;
          this.form.diameterCover = res.diameterCover;
          this.form.diameterRoom = res.diameterRoom;
          this.form.elevation = res.elevation;
          this.form.materialCover = res.materialCover;
          this.form.material = res.material;
          this.form.shapeCover = res.shapeCover;
          this.form.materialWell = res.materialWell;
          this.form.depth = res.depth;
          this.form.lnglat = res.x + "," + res.y;

          if (res.category === "sewage") {
            this.wellTypes = this.sewageWellTypes;
          } else {
            this.wellTypes = this.rainWellTypes;
          }

          const pipeList = [];
          if (Array.isArray(res.pipesFrom)) {
            res.pipesFrom.forEach((item) => {
              pipeList.push({
                ...item,
                type: item.category,
                location: "from",
              });
            });
          }

          if (Array.isArray(res.pipesTo)) {
            res.pipesTo.forEach((item) => {
              pipeList.push({
                ...item,
                type: item.category,
                location: "to",
              });
            });
          }

          this.pipeList = pipeList;
        })
        .finally(() => {
          hide();
        });
    },

    pasteLnglat() {
      const { lng, lat } = this.selectedLnglat;
      if (!lng) {
        this.$message.error("请点击地图选择经纬度");
        return;
      }
      this.form.lnglat = lng + "," + lat
    },

    onCategoryChange(value) {
      this.form.setFieldsValue({
        type: undefined,
      });

      if (value === "sewage") {
        this.wellTypes = this.sewageWellTypes;
      } else {
        this.wellTypes = this.rainWellTypes;
      }
    },

    handleSubmit() {
          if (this.isSubmitting) return;
          this.isSubmitting = true;
          if (!this.form.category) {
              this.$message.error('所属分类不能为空');
              this.isSubmitting = false;
              return;
          }
          if (!this.form.type) {
              this.$message.error('井类型不能为空');
              this.isSubmitting = false;
              return;
          }
          if (!this.form.code) {
              this.$message.error('编号不能为空');
              this.isSubmitting = false;
              return;
          }
          if (!this.form.lnglat) {
              this.$message.error('经纬度不能为空');
              this.isSubmitting = false;
              return;
          }
          const arr = this.form.lnglat.split(",");
          const x = parseFloat(arr[0]);
          const y = parseFloat(arr[1]);

          let flag = false;
          if (this.pipeList.length > 0) {
            this.pipeList.forEach((item) => {
              if (!item.location) {
                flag = true;
              }
            });
          }

          if (flag) {
            this.$message.error("请选择管线位置");
            return;
          }

          this.saveLoading = true;

          let params = {
            id: this.detail.id,
            ...this.form,
            x,
            y,
            pipePolicies: this.pipeList,
          };

          let task = add;
          if (this.detail.id) {
            task = edit;
          }
          task(params).then(() => {
              if (this.form.category === "rain") {
                this.getRainWellList();
              } else {
                this.getSewageWellList();
              }
              this.back();
            })
            .finally(() => {
              this.saveLoading = false;
            });
    },

    back() {
      this.wellTypes = [];
      this.detail = {};
        this.form = {
            category:null,
            type:null,
            code:null,
            lnglat:null,
            location:null,
            diameterCover:null,
            diameterRoom:null,
            elevation:null,
            materialCover:null,
            materialWell:null,
            shapeCover:null,
            depth:null,
        }
      this.pipeList = [];

      this.setSelectedLnglat({});
      this.setSelectedWell({});
      this.setSelectedPipe({});
      this.setView("检查井");
    },
  },
};
</script>

<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
